// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__ZXkIF","head":"Projects_head__h9n1A","title":"Projects_title__6eJS8","accent":"Projects_accent__WSPyp"};